import * as jobRepository from '../Repository/JobRepository';
import { getFeatureToggleList } from '../Reducers/FeatureToggleReducer.ts';
import { isPulseUser } from '../Utils/ConfigUtils';

function isJobTab(){
    return window.location.pathname?.includes('/jobs') || window.location.pathname === '/';
}

export default function fetchJobSourcingStats(jobIds) {
  return (dispatch, getState) => {
    if (jobIds && jobIds.length > 0) {
      const store = getState();
      const isOptimizedView = getFeatureToggleList(store)?.OptimizedCandidateSearch?.IsEnabled && isJobTab() && !isPulseUser();
      jobRepository
        .fetchJobSourcingStats(jobIds, isOptimizedView)
        .then(response => {
          const payload = response.data;
          dispatch({
            type: 'SET_JOB_SOURCING_STATS',
            payload,
          });
        })
        .catch(() => {
          dispatch({
            type: 'SET_ERROR',
            payload: {
              code: 'SOURCING_STATS_FETCH_FAILED',
              timeStamp: new Date(),
            },
          });
        });
    }
  };
}
